import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PasswordStrength from './PasswordStrength';
import CourseToggle from './CourseToggle';
import 'bootstrap/dist/css/bootstrap.min.css';

// Login Component
function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const handleLogin = (e) => {
    e.preventDefault();

    // Regular expression for validating the email format
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (email === '' || password === '') {
      setMessage('Please fill in all fields.');
    } else if (!emailRegex.test(email)) {
      setMessage('Invalid email format.');
    } else {
      // You can add API call here if needed
      setMessage('Login successful!');
      
      // Wait for 5 seconds and then redirect
      setTimeout(() => {
        navigate('/'); // Redirect using React Router
      }, 2000); // 2000 milliseconds = 2 seconds     
    }
  };

  // CSS styles defined as objects
  const messagestyles = {
    errorMessage: {
      color: 'red',
    },
    successMessage: {
      color: 'green', // or any other color for success messages
    },
    message: {
      marginTop: '10px',
    },
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px', padding: '20px' }}>
      <h2 className="card-title" style={{ marginBottom: '10px' }}>Login to LMS</h2>
      <form onSubmit={handleLogin}>
        <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ display: 'block', margin: '10px auto' }} />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ display: 'block', margin: '10px auto' }} />
        <button className="bg-dark btn btn-primary" type="submit">Login</button>
      </form>
      {message ? (
        <p className="card-text" style={{ 
          ...messagestyles.message, 
          ...(message === 'Invalid email format.' ? messagestyles.errorMessage : 
            message === 'Please fill in all fields.' ? messagestyles.errorMessage : 
            messagestyles.successMessage) 
        }}>
      {message}</p>
      ) : ( 
      <p className="card-text" style={{ ...messagestyles.message }}><br /></p> )}
      <Link to="/">Go back to Home</Link>      
      <PasswordStrength />
    </div>
  );
}

// Course Recommender Component
function CourseRecommender() {
  const [interest, setInterest] = useState('');
  const [recommended, setRecommended] = useState('');

  const recommendCourse = () => {
    if (interest.toLowerCase().includes('web')) {
      setRecommended('We recommend: React.js for Beginners');
    } else if (interest.toLowerCase().includes('data')) {
      setRecommended('We recommend: Intro to Data Science with Python');
    } else if (interest.toLowerCase().includes('ai')) {
      setRecommended('We recommend: Machine Learning with Scikit-Learn');
    } else {
      setRecommended('Please enter a valid interest (e.g., AI, Web, Data)');
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px', padding: '20px' }}>
      <h2 className="card-title" style={{ marginBottom: '10px' }}>AI Course Recommender</h2>
      <input type="text" placeholder="Enter your interest (e.g., AI, Web, Data)" value={interest} onChange={(e) => setInterest(e.target.value)} style={{ display: 'block', width: '300px', margin: '10px auto' }} />
      <button className="bg-dark btn btn-primary" onClick={recommendCourse} style={{ width: '190px', marginBottom: '10px' }}>Get Recommendation</button>
      {recommended ? (
        <p className="card-text" style={{ margin: '10px 0' }}>{recommended}</p>
      ) : (
        <p className="card-text" style={{ margin: '10px 0' }}><br /></p>
      )}
      <Link to="/">Go back to Home</Link>      
      {recommended === 'We recommend: React.js for Beginners' ? <CourseToggle /> : "" }
    </div>
  );
}

// Export both components
export { Login, CourseRecommender };
